(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  function initPDP(root) {
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-pdp-variants]').textContent); } catch (e) {}

    var idInput = root.querySelector('[data-pdp-variant-id]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var compareEl = root.querySelector('[data-pdp-compare]');
    var discountEl = root.querySelector('[data-pdp-discount]');
    var atcButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-atc], [data-pdp-sticky-atc]'));
    var atcTexts = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-atc-text]'));
    var valueBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-value]'));
    var optionEls = Array.prototype.slice.call(root.querySelectorAll('.pdp__option'));
    var savingsEl = root.querySelector('[data-pdp-savings]');

    var selected = optionEls.map(function (el) {
      var sel = el.querySelector('.pdp__value.is-selected');
      return sel ? sel.getAttribute('data-value') : null;
    });

    function setAtcText(txt) { atcTexts.forEach(function (el) { el.textContent = txt; }); }
    function setAtcDisabled(state) { atcButtons.forEach(function (b) { b.disabled = state; }); }

    function findVariant(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function updateAvailability() {
      valueBtns.forEach(function (btn) {
        var oi = parseInt(btn.getAttribute('data-option-index'), 10);
        var trial = selected.slice();
        trial[oi] = btn.getAttribute('data-value');
        var exists = variants.some(function (v) {
          return v.available && v.options.every(function (o, i) { return trial[i] == null || o === trial[i]; });
        });
        btn.classList.toggle('is-unavailable', !exists);
      });
    }

    /* ---- Gallery ---- */
    var stage = root.querySelector('[data-pdp-stage]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-dot]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));

    function setActiveIndex(i) {
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
    }
    function goToSlide(i, smooth) {
      if (!stage) return;
      stage.scrollTo({ left: stage.clientWidth * i, behavior: smooth === false ? 'auto' : 'smooth' });
      setActiveIndex(i);
    }
    if (stage) {
      var st;
      stage.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () { setActiveIndex(Math.round(stage.scrollLeft / stage.clientWidth)); }, 80);
      }, { passive: true });
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goToSlide(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goToSlide(i); }); });

    /* ---- Variant render ---- */
    function render() {
      var variant = findVariant(selected);
      optionEls.forEach(function (el, i) {
        var label = el.querySelector('[data-pdp-option-selected]');
        if (label) label.textContent = selected[i] || '';
      });
      updateAvailability();

      if (!variant) { setAtcDisabled(true); setAtcText('Unavailable'); return; }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price_formatted;
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = variant.compare_formatted; compareEl.hidden = false;
          if (discountEl) {
            discountEl.textContent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% OFF';
            discountEl.hidden = false;
          }
        } else { compareEl.hidden = true; if (discountEl) discountEl.hidden = true; }
      }
      setAtcDisabled(!variant.available);
      setAtcText(variant.available ? 'Add to cart' : 'Sold out');

      if (savingsEl) {
        if (variant.savings_formatted) {
          var msg = '<span class="pdp__savings-emoji">🎉</span> You save <strong>' + variant.savings_formatted +
                    '</strong> (' + variant.savings_pct + '% off) vs buying ' + variant.pack_qty + ' singles';
          var changed = savingsEl.innerHTML !== msg;
          savingsEl.innerHTML = msg;
          savingsEl.hidden = false;
          if (changed) {
            savingsEl.classList.remove('is-in');
            void savingsEl.offsetWidth; /* restart the entrance animation */
            savingsEl.classList.add('is-in');
          }
        } else {
          savingsEl.hidden = true;
          savingsEl.classList.remove('is-in');
        }
      }

      if (variant.media_id != null) {
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == variant.media_id; });
        if (idx >= 0) goToSlide(idx, false);
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    valueBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var oi = parseInt(btn.getAttribute('data-option-index'), 10);
        selected[oi] = btn.getAttribute('data-value');
        root.querySelectorAll('[data-pdp-value][data-option-index="' + oi + '"]').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });
        if (btn.classList.contains('pdp__pack')) {
          btn.classList.remove('is-pop');
          void btn.offsetWidth; /* restart the pop + sweep */
          btn.classList.add('is-pop');
        }
        render();
      });
    });

    /* ---- Quantity (synced across the in-page + sticky steppers) ---- */
    var qtyInputs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-qty-input]'));
    function getQty() { var n = parseInt(qtyInputs[0].value, 10); return (isNaN(n) || n < 1) ? 1 : n; }
    function setQty(n) { if (n < 1) n = 1; qtyInputs.forEach(function (i) { i.value = n; }); }
    root.querySelectorAll('[data-pdp-qty-minus]').forEach(function (b) { b.addEventListener('click', function () { setQty(getQty() - 1); }); });
    root.querySelectorAll('[data-pdp-qty-plus]').forEach(function (b) { b.addEventListener('click', function () { setQty(getQty() + 1); }); });
    qtyInputs.forEach(function (i) { i.addEventListener('change', function () { setQty(getQty()); }); });

    /* ---- Add to cart (shared by in-page form + sticky button) ---- */
    var form = root.querySelector('#ProductForm');
    var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    function addToCart() {
      if (atcButtons[0] && atcButtons[0].disabled) return;
      setAtcDisabled(true);
      setAtcText('Adding…');
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: idInput.value, quantity: getQty() }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return fetch(cartUrl + '.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          // Hand off to the cart drawer (sections/cart-drawer.liquid)
          try {
            if (window.HavmiCart && window.HavmiCart.open) {
              window.HavmiCart.open();
            } else {
              // Drawer section is not on the page — still get the customer to a cart,
              // and say why in the console instead of failing silently.
              console.warn('[Havmi] Cart drawer not found. Upload sections/cart-drawer.liquid and layout/theme.liquid.');
              window.location.href = cartUrl;
            }
          } catch (err) {
            console.error('[Havmi] Cart drawer failed to open:', err);
            window.location.href = cartUrl;
          }
          setAtcText('Added ✓');
          setTimeout(function () { setAtcText('Add to cart'); setAtcDisabled(false); }, 1600);
        })
        .catch(function () { setAtcDisabled(false); setAtcText('Add to cart'); if (form) form.submit(); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    var stickyAtc = root.querySelector('[data-pdp-sticky-atc]');
    if (stickyAtc) stickyAtc.addEventListener('click', addToCart);

    /* ---- Accordions (respect each item's initial open state) ---- */
    root.querySelectorAll('[data-pdp-acc-toggle]').forEach(function (head) {
      var body = head.parentElement.querySelector('[data-pdp-acc-body]');
      var open = head.classList.contains('is-open');
      if (body) body.classList.toggle('is-open', open);
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      head.addEventListener('click', function () {
        var o = head.classList.toggle('is-open');
        head.setAttribute('aria-expanded', o ? 'true' : 'false');
        if (body) body.classList.toggle('is-open', o);
      });
    });

    /* ---- Delivery estimate checker ---- */
    var delivery = root.querySelector('[data-delivery]');
    if (delivery) {
      var dForm = delivery.querySelector('[data-delivery-form]');
      var dInput = delivery.querySelector('[data-delivery-input]');
      var dResult = delivery.querySelector('[data-delivery-result]');
      var minD = parseInt(delivery.getAttribute('data-min'), 10) || 2;
      var maxD = parseInt(delivery.getAttribute('data-max'), 10) || 3;
      var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      function fmt(dt) { return DOW[dt.getDay()] + ', ' + dt.getDate() + ' ' + MON[dt.getMonth()]; }

      try { var saved = localStorage.getItem('havmi_pincode'); if (saved) dInput.value = saved; } catch (e) {}
      dInput.addEventListener('input', function () { dInput.value = dInput.value.replace(/\D/g, '').slice(0, 6); });

      dForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var pin = (dInput.value || '').trim();
        // Valid Indian PIN: 6 digits, first digit 1-9 (no leading zero).
        if (!/^[1-9][0-9]{5}$/.test(pin)) {
          dResult.hidden = false;
          dResult.className = 'delivery__result is-error';
          dResult.textContent = 'Please enter a valid 6-digit Indian pincode.';
          return;
        }
        try { localStorage.setItem('havmi_pincode', pin); } catch (e) {}
        var now = new Date();
        var a = new Date(now); a.setDate(a.getDate() + minD);
        var b = new Date(now); b.setDate(b.getDate() + maxD);
        var range = (minD === maxD) ? fmt(b) : (fmt(a) + ' – ' + fmt(b));
        var span = (minD === maxD) ? (minD + ' day') : (minD + '–' + maxD + ' days');
        dResult.hidden = false;
        dResult.className = 'delivery__result is-ok';
        var note = delivery.getAttribute('data-note') || '';
        dResult.innerHTML =
          '<strong>✓ Delivery available to ' + pin + '</strong>' +
          '<span>⚡ Fast delivery in ' + span + ' · Get it by <b>' + range + '</b></span>' +
          (note ? '<span class="delivery__note">' + note + '</span>' : '');
      });
    }

    render();
  }
  function init() { document.querySelectorAll('[data-pdp]').forEach(initPDP); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();
})();
